import { render, staticRenderFns } from "./lectureVideoDialog.vue?vue&type=template&id=4b9d09c1&scoped=true&"
import script from "./lectureVideoDialog.vue?vue&type=script&lang=js&"
export * from "./lectureVideoDialog.vue?vue&type=script&lang=js&"
import style0 from "./lectureVideoDialog.vue?vue&type=style&index=0&id=4b9d09c1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b9d09c1",
  null
  
)

export default component.exports